export const endpoints = {
  publicCandidateList: '/jobs/{id}/public-candidate-list',
} as const;

export const PUBLIC_SHORTLIST_SETTINGS_ID = 'public-shortlist';

// Sales, not support: keep separate from supportMailto()
// (src/modules/support/support.ts), which owns the one support inbox.
export const BOOK_CALL_URL =
  'https://meetings-eu1.hubspot.com/finlayteam/website-sign-up?uuid=39f748a6-5462-46ce-9048-df353de67440';

export const FINLAY_MARKETING_URL = 'https://finlay.ai';

export const FEATURED_CANDIDATE_COUNT = 4;

export const SHORTLIST_CARD_WORK_EXPERIENCE_COUNT = 4;

export const SHORTLIST_CTA_LABEL = 'Book a 15-minute call';

export const SHORTLIST_HEADER_CTA_LABEL = 'Talk to us';

export const SHORTLIST_FOOTER_CTA_LABEL = 'Request introductions';

export const PUBLIC_SHORTLIST_CODE_QUERY_PARAM = 'code';

export const SHORTLIST_MAX_WIDTH_CLASS = 'max-w-5xl xl:max-w-6xl';

export const SHORTLIST_OG_IMAGE_PATH = '/og-image.png';

/**
 * Opens the HubSpot booking page in a new tab and reports whether it actually
 * opened. We intentionally omit the `noopener` window feature here: with it set,
 * browsers return `null` even on success, which makes a blocked popup
 * indistinguishable from a successful one. Instead we sever the opener
 * relationship manually (the security benefit of `noopener`) while keeping the
 * returned reference so callers can surface an in-page fallback when the popup
 * is blocked.
 */
export function openBookCallLink(): boolean {
  const bookCallWindow = window.open(BOOK_CALL_URL, '_blank');

  if (
    !bookCallWindow ||
    bookCallWindow.closed ||
    typeof bookCallWindow.closed === 'undefined'
  ) {
    return false;
  }

  try {
    bookCallWindow.opener = null;
  } catch {
    // Ignore: severing the opener is best-effort and not critical.
  }

  return true;
}
